import React, { useEffect, useState } from 'react';
import { Image, Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';

import PromptButton, { BUTTON_TYPES } from 'components/base/prompt/BaseButtons';
import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import { PermissionCodes } from 'config/PermissionCodes';

import { SavedStatus } from '../../../config/CustomEnums';

import CloseIcon from '../../../assets/images/prompt_close_icon.svg';

const SettingDefaultMallPrompt = ({ saved, mallList, show, setShow }) => {
  const dispatch = useDispatch();

  const [selectedMall, setSelectedMall] = useState();
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (show) {
      dispatch({
        type: 'mall/getPagedMallList',
        payload: {
          noLoading: true,
          isSelectorLoad: true
        },
      });
    }
  }, [show]);

  const onClose = () => {
    setShow(false);
    dispatch({
      type: 'mall/clearAnotherData',
      payload: {},
    });
  };

  const saveAction = () => {
    setIsSaving(true);
    // dispatch({
    //   type: 'mall/update',
    //   payload: {},
    // });
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className={`base-prompt-container`}>
        <Image
          src={CloseIcon}
          className="base-prompt-close-button"
          onClick={onClose}
        />

        <div>
          <div className="base-prompt-header">Setting default mall</div>
          <div className="default-mall-setting-container">
            <label
              className={`create-section-label create-section-label-bottom-space`}
            >
              Set a mall to be the default mall. The customer will see the
              default mall's content when:
            </label>
            <ul>
              <li>In guest mode (not yet login)</li>
              <li>
                No location permission allowed (system cannot get the nearby
                mall), so cannot display the nearby mall
              </li>
            </ul>
            <CustomTitleWithDropDown
              title="Select mall"
              source={mallList}
              defaultValue={selectedMall}
              setValue={(value) => {
                setSelectedMall(value);
              }}
              loadMoreAction={'mall/getPagedMallList'}
              filterAction={'mall/getPagedMallList'}
              defaultFilter={{
                noLoading: true,
              }}
            />
          </div>
        </div>

        <div className="base-prompt-buttons">
          <PromptButton
            title="Cancel"
            action={onClose}
            type={BUTTON_TYPES.secondary}
          />
          <PromptButton
            title="Confirm"
            action={saveAction}
            requires={PermissionCodes.changeMall}
            type={BUTTON_TYPES.main}
            disabled={isSaving}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

const mapPropsToState = (state) => ({
  mallList: state.mall.mallList || [],
});

export default connect(mapPropsToState)(SettingDefaultMallPrompt);
